<template>
  <div>개인정보취급방침 준비중입니다.</div>
</template>

<script>
export default {};
</script>
